import type { PayoutItemDto } from '@paladin-monorepo/common';
import API from '../api';

export const payoutsApi = {
  async list(): Promise<PayoutItemDto[]> {
    return API.get<PayoutItemDto[]>('/payouts').then((r) => r.data);
  },
};
